import React from 'react';
import { TOUCH_TARGETS } from '../theme/tokens';
import './OptionsGrid.css';

interface OptionsGridProps {
  options: number[];
  correctAnswer: number;
  onSelect: (answer: number) => void;
  selectedAnswer?: number | null;
  showResult?: boolean;
  reducedMotion?: boolean;
}

const OptionsGrid: React.FC<OptionsGridProps> = ({
  options,
  correctAnswer,
  onSelect,
  selectedAnswer = null,
  showResult = false,
  reducedMotion = false
}) => {
  const getButtonClass = (option: number) => {
    let baseClass = 'option-button';
    
    if (showResult) {
      if (option === correctAnswer) {
        baseClass += ' correct';
      } else if (option === selectedAnswer && option !== correctAnswer) {
        baseClass += ' incorrect';
      } else {
        baseClass += ' neutral';
      }
    } else if (selectedAnswer === option) {
      baseClass += ' selected';
    }
    
    return baseClass;
  };

  const handleClick = (option: number) => {
    if (!showResult) {
      // Normal selection mode - allow any selection
      onSelect(option);
    } else if (showResult) {
      // Result mode - allow retrying any option
      onSelect(option);
    }
  };

  return (
    <div className="options-grid">
      {options.map((option) => (
        <button
          key={option}
          className={getButtonClass(option)}
          onClick={() => handleClick(option)}
          disabled={false}
          style={{
            minHeight: TOUCH_TARGETS.minSize,
            minWidth: TOUCH_TARGETS.minSize
          }}
        >
          {option}
        </button>
      ))}
    </div>
  );
};

export default OptionsGrid;
